// @ts-nocheck 83483a3a
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_strip'],
      sections: [addPanel.sections.getSections().strip.stripsSection],
    };
  },
};
